import { useTranslation } from "react-i18next";
import { Margin, PageSubtitle, PageTitle } from "../../widgets/small-widgets";
import { ThemeProvider } from "@emotion/react";
import theme from "../../style/theme";
import { Autocomplete, Button, Skeleton, TextField } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import { Platform, platformOptions, stringToPlatform } from "../../classes/enums.tsx";
import { getSolutionsByQuery, getSolutionsCategories } from "../../firebase/firestore/functions.tsx";
import { RetValCode } from "../../classes/retval.tsx";
import { useState } from "react";
import { translateCategories } from "../../classes/utils/categories.tsx";
import { Solution } from "../../classes/solution.tsx";
import { LoadingSolutions } from "../../widgets/solutions/loading.jsx";
import { SolutionCard } from "../../widgets/solutions/cards.jsx";

export default function SolutionsPage() {
    const { t } = useTranslation();

    const [solutions, setSolutions] = useState(null);
    const [options, setOptions] = useState(null);
    const [loading, setLoading] = useState(false);

    async function getOptions() {
        const data = await getSolutionsCategories();
        
        if (data.getCode() === RetValCode.OK) {
            console.log(data.getData());
            setOptions(data.getData());
        } else {
            //TODO: show error
        }
    }

    if (options === null) {
        getOptions();
    }

    async function getSolutions() {
        setLoading(true);

        const category = document.getElementById('category')?.value;
        const platform = document.getElementById('platform')?.value;
        const index = translateCategories(options, t).indexOf(category)

        console.log(category, platform);

        const result = await getSolutionsByQuery(index !== -1 ? options[index] : null, platform.length === 0 ? null : stringToPlatform(platform) !== Platform.null ? stringToPlatform(platform) : null);
        if (result.getCode() === RetValCode.OK) {
            setSolutions(result.getData());
        } else {
            //TODO: show error
            setSolutions(null);
        }

        setLoading(false);
    }

    console.log(solutions);

    return <div style={{padding: '1.2rem'}}>
        <PageTitle>{t('navigation.solutions')}</PageTitle>
        <Margin height={10}/>
        <form noValidate onSubmit={(e) => {
            e.preventDefault();

            getSolutions(true);
        }}>
            <ThemeProvider theme={theme}>
                <div style={{display: 'flex', gap: '10px'}}>
                    {options !== null && options !== undefined
                        ? <Autocomplete
                            id="category"
                            disablePortal
                            options={translateCategories(options, t)}
                            sx={{ width: '100%', margin: '8px' }}
                            renderInput={(params) => <TextField {...params} label={t('solutions.filter.category')} variant="outlined"/>}
                        /> : <Skeleton variant="rounded" width={'100%'} height={40} />
                    }
                    <Autocomplete
                        id="platform"
                        disablePortal
                        options={platformOptions}
                        sx={{ width: '100%', margin: '8px' }}
                        renderInput={(params) => <TextField {...params} label={t('solutions.filter.platform')} variant="outlined"/>}
                    />
                </div>
                <div style={{display: 'flex', gap: '10px'}}>
                    <div style={{width:'100%', height: 50, margin:'8px'}}>
                        <Button variant="contained" sx={{ width:'100%', height: '100%', fontWeight: 'bold' }} endIcon={<SearchOutlined/>} type="submit">{t('solutions.filter.search')}</Button>
                    </div>
                </div>
            </ThemeProvider>
        </form>
        <Margin height={25}/>
        {loading === true
            ? <LoadingSolutions number={5}/>
            : solutions === null || solutions === undefined
                ? null
                : solutions.length === 0
                    ? <div style={{width: '100%', textAlign: 'center'}}>
                        <PageSubtitle>{t('solutions.filter.noResults')}</PageSubtitle>
                    </div>
                    : <>
                        <div className="solutions-grid solutions-container">
                            {solutions.map((solution, index) => solution.cardDraw())}
                        </div>
                    </>
        }
    </div>;
}